(function () {
  function initTestimonials(section) {
    if (!section || section.dataset.slTestimonialsInitialized === 'true') return;
    section.dataset.slTestimonialsInitialized = 'true';

    var track = section.querySelector('.sl-home-testimonials__track');
    var slides = Array.prototype.slice.call(section.querySelectorAll('.sl-home-testimonials__card'));
    var prev = section.querySelector('.sl-home-testimonials__arrow--prev');
    var next = section.querySelector('.sl-home-testimonials__arrow--next');
    var dotsWrap = section.querySelector('.sl-home-testimonials__dots');

    if (!track || !slides.length || !prev || !next || !dotsWrap) return;

    var current = 0;
    var dots = [];

    function getGap() {
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0);
      return isNaN(gap) ? 0 : gap;
    }

    function getPerPage() {
      if (window.innerWidth <= 900) return 1;
      if (window.innerWidth <= 1100) return 2;
      return 3;
    }

    function getMaxIndex() {
      return Math.max(0, slides.length - getPerPage());
    }

    function buildDots() {
      dotsWrap.innerHTML = '';
      dots = [];

      var maxIndex = getMaxIndex();

      for (var i = 0; i <= maxIndex; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sl-home-testimonials__dot';
        dot.setAttribute('aria-label', 'Bewertungen Seite ' + (i + 1) + ' anzeigen');

        (function (index) {
          dot.addEventListener('click', function () {
            current = index;
            update();
          });
        })(i);

        dotsWrap.appendChild(dot);
        dots.push(dot);
      }

      if (dots.length <= 1) {
        dotsWrap.style.display = 'none';
      } else {
        dotsWrap.style.display = 'flex';
      }
    }

    function update() {
      var maxIndex = getMaxIndex();

      if (current > maxIndex) current = maxIndex;
      if (current < 0) current = 0;

      var slideWidth = slides[0].getBoundingClientRect().width;
      var offset = current * (slideWidth + getGap());

      track.style.transform = 'translateX(-' + offset + 'px)';

      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === current);
        dot.setAttribute('aria-current', index === current ? 'true' : 'false');
      });

      prev.disabled = current === 0;
      next.disabled = current === maxIndex;

      prev.style.opacity = current === 0 ? '0.55' : '1';
      next.style.opacity = current === maxIndex ? '0.55' : '1';
    }

    prev.addEventListener('click', function () {
      current -= 1;
      update();
    });

    next.addEventListener('click', function () {
      current += 1;
      update();
    });

    window.addEventListener('resize', function () {
      buildDots();
      update();
    });

    buildDots();
    update();
  }

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('.sl-home-testimonials').forEach(initTestimonials);

    if (root.matches && root.matches('.sl-home-testimonials')) {
      initTestimonials(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
